export interface ReportExportRequestBody {
  ReportID?: string;
  SiteNumbers: string[];
  LaneNumbers: string[];
  ReportStartDateTime: Date;
  ReportEndDateTime: Date;
  RequestedOn: Date;
  Language: string;
  ExportPeriodBreakdown: string;
}

export interface ReportExportRequestBodyPayload {
  ReportID?: string;
  SiteNumbers: string[];
  LaneNumbers: string[];
  ReportStartDateTime: string;
  ReportEndDateTime: string;
  RequestedOn: string;
  Language: string;
  ExportPeriodBreakdown: string;
  ReportExportSource: ReportExportSource;
}

export enum ReportExportSource {
  Unknown = 0,
  VisionIQ,
  NotificationService,
}
